import React from 'react';

export const InfoIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16A8 8 0 108 0a8 8 0 000 16zm.889-11.554a.851.851 0 01-.26.628.853.853 0 01-.626.26.863.863 0 01-.63-.26.849.849 0 01-.262-.628c0-.245.088-.455.263-.63a.858.858 0 01.629-.26c.244 0 .453.087.626.26a.86.86 0 01.26.63zm0 7.52c-.279.156-.502.275-.668.356-.166.082-.36.122-.579.122-.338 0-.6-.116-.788-.349-.187-.233-.281-.528-.281-.886 0-.14.007-.282.021-.427a7.13 7.13 0 01.068-.493l.349-1.744c.03-.167.057-.325.078-.475.021-.148.032-.285.032-.408 0-.223-.033-.378-.098-.466-.065-.088-.189-.132-.373-.132-.09 0-.183.02-.277.06-.095.04-.15-.424-.15-.424.228-.131.446-.244.655-.337.209-.094.406-.14.593-.14.335 0 .594.114.776.343.181.229.272.526.272.893 0 .075-.006.209-.018.4a3.687 3.687 0 01-.07.525l-.348 1.737a6.329 6.329 0 00-.11.884c0 .231.037.388.11.472.073.084.2.125.38.125.084 0 .18-.02.287-.062.106-.042.139.427.139.427z"
            fill="currentColor"
        />
    </svg>
);
